export default {
    manage_account: 'Manage Account',
    profile: 'Profile',
    logout: 'Log Out',
    my_plan: 'My Plan',
    billing: 'Billing',
    creditsLabel: 'Credits',
    apiTokens: 'API Tokens',
    manageApiTokens: 'Manage API Tokens',
    manageTeam: 'Manage Team',
    teamSettings: 'Team Settings',
    createNewTeam: 'Create New Team',
};
